import React, { useContext, Fragment } from 'react';
import format from 'date-fns/format';
import ReactPaginate from 'react-paginate';
import ListingTypeSlider from '../ListingTypeSlider';
import NoResults from '../NoResults';
import { EventMapContext } from '../../context/EventMapContext';

const EventsGrouped = ({ loading, events, meta }) => {
  const { setCurrentPage, currentPage } = useContext(EventMapContext);

  // Event Grouping Logic for Sliders
  const checked = [];
  const groupedEvents = {};

  events.forEach(event => {
    // If another event with the same date has not already been checked
    if (checked.indexOf(event.start_date.slice(0, 10)) === -1) {
      // Then add a key equal to the event's date in the groupedEvents obj
      // And set it equal to an array where all event objects with the same date will be stored
      groupedEvents[event.start_date.slice(0, 10)] = [];
      // Then add the event obj to the array we just created
      groupedEvents[event.start_date.slice(0, 10)].push(event);
      // Then Add the date to the checked array
      checked.push(event.start_date.slice(0, 10));
      // If the event has been checked
    } else {
      groupedEvents[event.start_date.slice(0, 10)].push(event);
    }
  });

  const dates = Object.keys(groupedEvents);
  const sortedDates = dates.sort((a, b) => {
    if (new Date(a) > new Date(b)) {
      return 1;
    }
    if (new Date(a) < new Date(b)) {
      return -1;
    }
    return 0;
  });

  return (
    <Fragment>
      <h1 className="page-title" style={{ marginTop: '85px' }}>
        Upcoming Events
      </h1>
      <div className="events-section">
        {loading && !events.length ? (
          <Fragment>
            <ListingTypeSlider listing_type="loading" display="none" />
            <ListingTypeSlider listing_type="loading" display="none" />
            <ListingTypeSlider listing_type="loading" display="none" />
            <ListingTypeSlider listing_type="loading" display="none" />
          </Fragment>
        ) : (
          <Fragment>
            {sortedDates.length ? (
              <Fragment>
                {sortedDates.map(date => (
                  <ListingTypeSlider
                    key={date}
                    listings={groupedEvents[date]}
                    title={format(date, 'MMM D, YYYY')} // February 21, 2019
                    listing_type="events"
                    display="none"
                  />
                ))}
                <section className="card-section-footer">
                  {parseInt(meta.total_count) > parseInt(meta.per_page) && (
                    <ReactPaginate
                      pageCount={parseInt(meta.total_pages)}
                      pageRangeDisplayed={2}
                      marginPagesDisplayed={1}
                      onPageChange={({ selected }) => {
                        setCurrentPage(
                          Math.min(selected + 1, meta.total_pages)
                        );
                      }}
                      forcePage={currentPage - 1}
                      containerClassName="pagination"
                      pageClassName="page"
                      activeClassName="current"
                      nextClassName="next"
                      previousClassName="prev"
                      breakClassName="page gap"
                      nextLabel=""
                      previousLabel=""
                    />
                  )}
                  <p>
                    {meta.per_page * meta.current_page - meta.per_page + 1} -{' '}
                    {Math.min(
                      meta.per_page * meta.current_page,
                      meta.total_count
                    )}{' '}
                    of {meta.total_count} <span>Events</span>
                  </p>
                </section>
              </Fragment>
            ) : (
              <NoResults />
            )}
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};

export default EventsGrouped;
